export enum UserRole {
  GUEST = 'guest',
  HOST = 'host',
  ADMIN = 'admin',
}

export interface User {
  id: string;
  cognitoId: string;
  email: string;
  role: UserRole;
  createdAt: Date;
  updatedAt: Date;
}

export interface UserAgreements {
  id: string;
  userId: string;
  termsAccepted: boolean;
  termsAcceptedAt?: Date;
  photoConsent: boolean;
  photoConsentAt?: Date;
  refundPolicyAccepted: boolean;
  refundPolicyAcceptedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}
